//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import Cuid from '@models/Cuid';
import { SchedulerSocialNetwork } from '@universal-scheduling/models/SocialNetworkModels';

export interface GetRecommendedAiHashtagsRequest {
  caption: string;
  cuid?: Cuid;
  network: SchedulerSocialNetwork;
  networkUserId?: string;
  username: string;
}

export interface RecommendedAiHashtagsResponse {
  hashtags: string[];
}

export interface GetRecommendedAiCaptionRequest {
  cuid?: Cuid;
  network: SchedulerSocialNetwork;
  networkUserId?: string;
  username: string;
}

export interface RecommendedAiCaptionResponse {
  caption: string;
}

export interface GetRecommendedAiCaptionModificationRequest {
  captionModificationType: CaptionModificationType;
  currentCaption: string;
  network: SchedulerSocialNetwork;
  networkUserId?: string;
  username: string;
}

export interface RecommendedAiCaptionModificationResponse {
  caption: string;
}

export enum CaptionModificationType {
  ChangeToneToCasual = 'ChangeToneToCasual',
  ChangeToneToConfident = 'ChangeToneToConfident',
  ChangeToneToFriendly = 'ChangeToneToFriendly',
  ChangeToneToProfessional = 'ChangeToneToProfessional',
  ChangeToneToStraightforward = 'ChangeToneToStraightforward',
  FixSpellingAndGrammar = 'FixSpellingAndGrammar',
  MakeLonger = 'MakeLonger',
  MakeShorter = 'MakeShorter',
  OptimizeForPlatform = 'OptimizeForPlatform',
  SimplifyLanguage = 'SimplifyLanguage',
}
